import { MesfModal } from "@dexteel/mesf-core";
import { Button, DialogContentText } from "@mui/material";
import { modalStyles } from "@/shared/styles/modalStyles";

export interface ConfirmationDialogRawProps {
  title: string;
  message?: string;
  open: boolean;
  onClose: (value?: string) => void;
  confirmText?: string;
}
export const ConfirmationDialogRaw = ({
  title,
  message,
  open,
  onClose,
  confirmText = "Ok",
}: ConfirmationDialogRawProps) => {
  const handleCancel = () => {
    onClose("Cancel");
  };
  const handleOk = () => {
    onClose("OK");
  };
  return (
    <MesfModal
      title={title}
      open={open}
      handleClose={handleCancel}
      id="confirmation-dialog"
      maxWidth="xs"
    >
      <MesfModal.Content
        dividers
        sx={{
          ...modalStyles.modalContent,
          minWidth: { xs: "auto", sm: 400 },
        }}
      >
        <DialogContentText>{message}</DialogContentText>
      </MesfModal.Content>
      <MesfModal.Actions sx={modalStyles.modalActions}>
        <Button
          autoFocus
          variant="contained"
          color="inherit"
          onClick={handleCancel}
          sx={{ minWidth: 120 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOk}
          sx={{ minWidth: 120 }}
        >
          {confirmText}
        </Button>
      </MesfModal.Actions>
    </MesfModal>
  );
};
